import React from 'react';
import icareLogo from '../../images/icare-logo.png';

const Header = () => {
  return (
    <section className="section has-text-centered">
      <div className="is-flex is-flex-direction-column is-justify-content-center is-align-items-center">
        <div>
          <img
            src={icareLogo}
            alt="iCARE Logo"
            className="image"
            style={{ maxWidth: '250px' }}
          />
        </div>
        <div className="mt-5">
          <a
            href="https://mydrkatz.com/#/login/csbh"
            className="button is-light has-text-weight-semibold has-text-white has-background-primary"
          >
            iCARE Log in
          </a>
        </div>
        <div className="mt-5" style={{ width: '100%', maxWidth: '560px' }}>
          <figure className="image is-16by9">
            <iframe
              className="has-ratio"
              src="https://www.youtube.com/embed/eSh3ARQF2VU?si=urQW8SxeyxtMWVrz"
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            />
          </figure>
        </div>
        <div className="mt-5">
          <p className="has-text-weight-semibold mb-3">iCARE Directions</p>
          <p className="has-text-weight-semibold mb-2">English</p>
          <div className="is-flex is-flex-wrap-wrap is-justify-content-center" style={{ gap: '1rem' }}>
            <a
              href="/iCARE_program_flier.pdf"
              download="iCARE_Program_Flier.pdf"
              className="button is-light has-text-weight-semibold has-text-white has-background-primary"
            >
              iCARE Program Flier
            </a>
            <a
              href="/iCARE_create_account.pdf"
              download="iCARE_Create_Account.pdf"
              className="button is-light has-text-weight-semibold has-text-white has-background-primary"
            >
              iCARE Create Account
            </a>
            <a
              href="/iCARE_promo_flier.pdf"
              download="iCARE_Promo_Flier.pdf"
              className="button is-light has-text-weight-semibold has-text-white has-background-primary"
            >
              iCARE Promo Flier
            </a>
          </div>
          <p className="has-text-weight-semibold mb-2 mt-4">Espa&#241;ol</p>
          <div className="is-flex is-flex-wrap-wrap is-justify-content-center" style={{ gap: '1rem' }}>
            <a
              href="/iCARE_program_flier_es.pdf"
              download="Folleto_del_programa_iCARE.pdf"
              className="button is-light has-text-weight-semibold has-text-white has-background-primary"
            >
              Folleto del programa iCARE
            </a>
            <a
              href="/iCARE_create_account_es.pdf"
              download="iCARE_crear_cuenta.pdf"
              className="button is-light has-text-weight-semibold has-text-white has-background-primary"
            >
              iCARE crear cuenta
            </a>
            <a
              href="/iCARE_promo_flier_es.pdf"
              download="Folleto_promocional_de_iCARE.pdf"
              className="button is-light has-text-weight-semibold has-text-white has-background-primary"
            >
              Folleto promocional de iCARE
            </a>
          </div>
          <p className="has-text-weight-semibold mb-2 mt-4">Portugu&#234;s</p>
          <div className="is-flex is-flex-wrap-wrap is-justify-content-center" style={{ gap: '1rem' }}>
            <a
              href="/iCARE_program_flier_pt.pdf"
              download="Folheto_do_Programa_iCARE.pdf"
              className="button is-light has-text-weight-semibold has-text-white has-background-primary"
            >
              Folheto do Programa iCARE
            </a>
            <a
              href="/iCARE_create_account_pt.pdf"
              download="Criar_conta_iCARE.pdf"
              className="button is-light has-text-weight-semibold has-text-white has-background-primary"
            >
              Criar conta iCARE
            </a>
            <a
              href="/iCARE_promo_flier_pt.pdf"
              download="Folheto_promocional_do_iCARE.pdf"
              className="button is-light has-text-weight-semibold has-text-white has-background-primary"
            >
              Folheto promocional do iCARE
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Header;
